import React, { useEffect, useState } from 'react';
import { Skeleton, Empty, Row, Col, Checkbox } from 'antd';
import { Button, Radio, Statistic, Space, Card, Tooltip, Form, PageHeader, Input, Select, Divider, Spin } from 'antd';
import Chart from 'react-apexcharts'
import ApexCharts from "apexcharts";
import './DonutGraph.css';
import { withRouter } from 'react-router-dom';


export const BarChartWidget = ({ isPrinting, ...props }) => {
    const [image, setImage] = useState(null)
    useEffect(() => {
        setImage(null)
        // console.log("Donut chart is printing", isPrinting, props)
        if (isPrinting && props.value?.length && props.answerKey?.length&& ApexCharts.exec(props.id ?? props.title, "dataURI")) {
            ApexCharts.exec(props.id ?? props.title, "dataURI").then(({ imgURI }) => {
                //console.log("Got bar graph image", imgURI)
                setImage(imgURI);
            });
        }
    }, [isPrinting, props.value?.length, props.answerKey?.length])

    if (image) {
        return (
            <div className={props.className || ''}>
                <h3 className='graph__title'>{props.title}</h3>
                <img src={image} style={{ width: '100%', objectFit: 'contain' }} />
            </div>
        )
    }

    return (
        <div>
            <h3 className='graph__title'>{props.title}</h3>


            {!props.answerKey && <div className="not-draggable" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', marginTop: 20 }}><Spin size="large" /></div> || null}
            {props.value && props.value.length == 0 && (<div className="not-draggable" style={{ alignItems: 'center', height: props.chartHeight - 30, width: props.chartWidth, justifyContent: 'center', display: 'flex' }}><span style={{ background: 'black', color: 'white', display: 'inline-block', padding: '5px 10px', borderRadius: '15px' }}>Trenutno nema podataka</span></div> || null) || null}

            {props.answerKey && props.answerKey.length && (
                <Chart
                    className="not-draggable scrollableBarChart"
                    width={props.chartWidth || '100%'}
                    height={(props.answerKey.length+1 )* 50 || 'auto'}
                    options={{
                        chart: {
                            id: props.id ?? props.title,
                            
                            type: 'bar',
                            animations:{
                                enabled:false,
                            }
                          
                        },
                        colors: ['#ccba78', '#788ACC', '#CC78B4', '#78CC90', '#536ABE', '#78B4CC', '#9078CC', '#8ACC78', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928',
                            '#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
                        plotOptions: {
                            bar: {
                                barHeight: 58,
                                borderRadius: 10,
                                distributed: true,
                                horizontal: true,
                                dataLabels: {
                                    position: 'bottom'
                                },
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            textAnchor: 'start',
                            style: {
                                colors: ['#000']
                            },
                            formatter: function (val, opt) {
                                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                            },
                            offsetY: -18,
                            offsetX: -3,
                            dropShadow: {
                                color:['#fff'],
                                enabled: true
                            }
                        },
                        stroke: {
                            width: 1,
                            colors: ['#fff']
                        },

                        xaxis: {
                            offsetY:10,
                            categories: props.answerKey,
                            labels: {
                                show: true
                            }

                        },
                        legend: {
                            show: false,
                        },

                        yaxis: {
                            labels: {
                                show: false
                            }
                        },
                        tooltip: {
                            x: {
                                show: true
                            },
                            y: {
                                title: {
                                    formatter: function () {
                                        return ''
                                    }
                                }
                            }
                        },
                    }
                    }

                    series={[{ data: props.value }]}
                    type={props.type || "bar"}
                />
            ) || null}


        </div>

    )
}